import formName from 'constants/formName'
import { actions, actionTypes, selectors } from 'data'
import { notifyError, notifySuccess } from 'data/App/sagas'
import { call, put, select, takeEvery } from 'redux-saga/effects'
import { requestHistory } from 'services/api/order'
import { Response } from 'utils/fetchApi'

const requestHistorySaga = function* (action) {
  const data: Response<void> = yield call(requestHistory, action.payload)
  const email: string = yield select(selectors.auth.getEmail)

  if (!data.ok) {
    yield put(actions.form.change(formName.REQUEST_HISTORY, 'year', ''))
    yield call(notifyError, data.error.cause, 'KO_GENERIC')
    return
  }
  // response returns {isQueued: true} or {isQueued: false}
  // if isQueued is false it means they already have a pending email
  yield call(notifySuccess, 'OK_REQUEST_HISTORY', 5, 'OK_REQUEST_HISTORY_DESC', email)
}

export default function* requestHistoryMain() {
  yield takeEvery(actionTypes.requestHistory.REQUEST_HISTORY, requestHistorySaga)
}
